import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@components/atoms/Button';
import { Slider } from '@components/atoms/Slider';
import { CardHeader } from '@components/molecules/CardHeader';
import { Overlay } from '@components/organisms/Overlay';

import { commonMessages } from '../../../../intl';

import * as S from './styles';
import { IProps } from './types';

export const CustomTrack: React.FC<IProps> = ({
  show,
  hide,
  target,
  attribute,
  onChange,
  value,
  defaultValue,
  minValue,
  maxValue,
}: IProps) => {
  const intl = useIntl();
  const filteredAttributeValues = useMemo(
    () =>
      attribute.values.filter(
        (_value) =>
          Number(_value.slug) >= Number(minValue) &&
          Number(_value.slug) <= Number(maxValue)
      ),
    [attribute, minValue, maxValue]
  );

  const [innerValue, setInnerValue] = useState(value);

  const handleChange = (newValue) => {
    setInnerValue(newValue);
  };

  const handleReset = () => {
    setInnerValue(defaultValue);
  };

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <Overlay position="fit" show={show} hide={hide} target={target}>
      <S.Modal>
        <CardHeader divider onHide={hide}>
          {intl.formatMessage({
            defaultMessage: 'Select custom rail size',
            id: 'r7m0tp',
          })}
        </CardHeader>
        <S.Content>
          <S.Wrapper>
            <S.Row>
              <S.Slider>
                <S.EdgeValues type="min" active={minValue === innerValue}>
                  {parseInt(minValue, 10) / 10} cm
                </S.EdgeValues>
                <Slider
                  values={filteredAttributeValues}
                  onChange={handleChange}
                  value={innerValue}
                />
                <S.EdgeValues type="max" active={maxValue === innerValue}>
                  {parseInt(maxValue, 10) / 10} cm
                </S.EdgeValues>
              </S.Slider>
              <S.ResetButton type="button" onClick={handleReset}>
                {intl.formatMessage({
                  defaultMessage: 'reset to default',
                  id: 'D3Xqos',
                })}
              </S.ResetButton>
            </S.Row>
            <S.Message>
              {attribute.getMessage && attribute.getMessage(value)}
            </S.Message>
            <S.Row buttons>
              <Button
                appearance="ghost"
                size="sm"
                className="button cancel"
                onClick={hide}
              >
                <span>{intl.formatMessage(commonMessages.cancel)}</span>
              </Button>
              <Button
                size="sm"
                className="button"
                onClick={() => {
                  onChange(String(innerValue));
                  hide();
                }}
              >
                <span>{intl.formatMessage(commonMessages.save)}</span>
              </Button>
            </S.Row>
          </S.Wrapper>
        </S.Content>
      </S.Modal>
    </Overlay>
  );
};
